import React, { useEffect, useRef, useState } from "react";
import userdashboardlogo from "../../../images/user-dashboard-logo.svg";
import Star2 from "../../../images/Star-2.svg";
import eurgbpflag from "../../../images/eurgbp-flag.svg";
import user from "../../../images/user.png";
import dashlefticon01 from "../../../images/dash-left-icon01.svg";
import dashlefticon02 from "../../../images/dash-left-icon02.svg";
import dashlefticon04 from "../../../images/dash-left-icon04.svg";
import dashrighticon02 from "../../../images/dash-right-icon02.svg";
import dashlefticon03 from "../../../images/dash-left-icon03.svg";
import dashlefticon05 from "../../../images/dash-left-icon05.svg";
import oppositearrow from "../../../images/opposite-arrow.svg";
import partnership from "../../../images/partnership.svg";
import facebook from "../../../images/facebook.png";
import telegramChart from "../../../images/telegram-chart.png";
import instagram from "../../../images/instagram.png";
import telegram2line from "../../../images/telegram-2-line.svg";
import telegram from "../../../images/telegram.png";
import closeIcon from "../../../images/closeIcon.svg";
import youtube from "../../../images/logo_youtube.png";
import twitter from "../../../images/x_logo_twitter.png";
import christmassantalogo from "../../../images/christmas-santa.png";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { authcallApi, authcallApipost } from "../../common/API/Api";
import { handleToggleCollapse, useModal } from "../../common/Collapsfunction";
import { useDispatch, useSelector } from "react-redux";
import { setData } from "../../../store/dataSlice";
import { setLivewallet } from "../../../store/walletSlice";
import { useTranslation } from "react-i18next";
import { useNotification } from "../../common/Notification";
import { formatPrice, formatPricewithdesimal } from "../../common/formatPrice";
import Sidebartabs from "./commonmodal/Commontabs";
import CommonDropdown from "../../common/CommonDropdown";
import { Dropdown } from "react-bootstrap";
import { LanguageSelector } from "./commonmodal/Commondropdowns";
import { formatName } from "../../common/nameFormatter";
import { getBaseUrl } from "../../common/BaseUrl";
import { convertLocalToUTCFormatted } from "./commonmodal/Formatedtime";
const Dashboardmenus = (props) => {
  const [isRotating, setIsRotating] = useState(false);
  const { t } = useTranslation();
  const previousValueRef = useRef(null);
  const { showNotification } = useNotification();
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [activeCollapseId, setActiveCollapseId] = useState(null);
  const [supportallcount, setSupprotallcount] = useState(0);
  const [showsavewallet, setShowsavewallet] = useState(false);
  const [version, setVersion] = useState("");
  const [updatetimezone, setUpdateTimezone] = useState();
  const [copied, setCopied] = useState(false);
  const [ballcount, setBallcount] = useState(0);
  const getRandom = (min, max) => Math.random() * (max - min) + min;
  const [flakes, setFlakes] = useState([]);
  const [showArrow, setShowArrow] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [balliconlist, setBalliconlist] = useState([]);
  const handleCopy = (textToCopy) => {
    navigator.clipboard.writeText(textToCopy).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // reset after 2s
      showNotification("Copied to clipboard!", "success");
    });
  };
  const handleRefresh = async () => {
    setIsRotating(true); // Start rotating
    await gettradesummary(); // Fetch data
    setTimeout(() => setIsRotating(false), 1000); // Stop rotation after 1s
  };
  let base_url = getBaseUrl();
  const {
    seriesRef,
    checknotifications,
    setChecknotifications,
    walletupdate,
    favorites,
    setshowtradeasset,
    setfavs,
    setCheckliveaccount,
    setWalletprice,
    showassetactive,
  } = props;

  const scrollContainerRef = useRef(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [activekeys, setActivekeys] = useState(false);
  const [transfer, setTransfer] = useState({
    from: { label: "Wallet", value: "wallet" },
    to: { label: "Safe", value: "safe" },
    amount: "",
  });
  const [error, setError] = useState("");
  const gethotkeys = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/preference?key=hotkey`, "GET");
      if (res?.data?.success) {
        setActivekeys(parseInt(res?.data?.value));
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    gethotkeys();
  }, []);
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const tooltipTriggerList = document.querySelectorAll(
        '[data-bs-toggle="tooltip"]',
      );
      tooltipTriggerList.forEach((el) => {
        if (!el.getAttribute("data-bs-original-title")) {
          new window.bootstrap.Tooltip(el);
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    if (activekeys) {
      const handleKeyDown = (event) => {
        if (event.shiftKey && event.key === "Tab") {
          event.preventDefault();
          setSelectedIndex((prevIndex) => {
            const newIndex =
              prevIndex > 0 ? prevIndex - 1 : favorites.length - 1;
            setshowtradeasset(favorites[newIndex], "chartasset");
            return newIndex;
          });
        }
      };
      window.addEventListener("keydown", handleKeyDown);
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    }
  }, [favorites, setshowtradeasset]);
  const scrollLeft = () => {
    scrollContainerRef.current.scrollBy({ left: -200, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollContainerRef.current.scrollBy({ left: 200, behavior: "smooth" });
  };

  const dispatch = useDispatch();
  const data = useSelector((state) => state.data.value);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const { modalRefs, openModal } = useModal();
  const [editamount, setEditamount] = useState(data);
  const [showedit, setShowedit] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [addactivecalss, setAddactiveclass] = useState({
    Trading: false,
    Finance: false,
    Profile: false,
    Analytics: false,
    Market: false,
    Support: false,
  });

  const location = useLocation();
  const state = location.state;

  const { section } = useParams();
  const collapseRef = useRef(null);
  const [accountsetup, setAccountsetup] = useState("");
  const [walletamount, setWalletamount] = useState({
    demo: "",
    real: "",
    safe: "",
  });
  const [displayAmount, setDisplayAmount] = useState(0);
  const pathSegments = location.pathname.split("/");
  const previousPathRef = useRef(location.pathname);
  const hasMountedOnce = useRef(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [notificationslist, setNotificationslist] = useState([]);
  const enterFullScreen = () => {
    const elem = document.documentElement;
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    }
    setIsFullScreen(true);
  };
  const exitFullScreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
    setIsFullScreen(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Escape" && isFullScreen) {
      exitFullScreen();
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isFullScreen]);
  useEffect(() => {
    if (pathSegments[2] === "userdashboard") {
      setAddactiveclass((state) => ({
        ...state,
        Trading: true,
        Finance: false,
        Profile: false,
        Analytics: false,
        Market: false,
        Support: false,
      }));
    } else if (pathSegments[2] === "userdashboarddeposit") {
      setAddactiveclass((state) => ({
        ...state,
        Finance: true,
        Trading: false,
        Profile: false,
        Analytics: false,
        Market: false,
        Support: false,
      }));
    } else if (pathSegments[2] === "accounthistory") {
      setAddactiveclass((state) => ({
        ...state,
        Finance: false,
        Trading: false,
        Profile: true,
        Analytics: false,
        Market: false,
        Support: false,
      }));
    } else if (pathSegments[2] === "analytics") {
      setAddactiveclass((state) => ({
        ...state,
        Finance: false,
        Trading: false,
        Profile: false,
        Analytics: true,
        Market: false,
        Support: false,
      }));
    } else if (pathSegments[2] === "marketdashboard") {
      setAddactiveclass((state) => ({
        ...state,
        Finance: false,
        Trading: false,
        Profile: false,
        Analytics: false,
        Market: true,
        Support: false,
      }));
    } else if (pathSegments[2] === "supportdashboard") {
      setAddactiveclass((state) => ({
        ...state,
        Finance: false,
        Trading: false,
        Profile: false,
        Analytics: false,
        Market: false,
        Support: true,
      }));
    }
  }, []);
  const terminatsessions = async (id) => {
    try {
      let array = [];
      console.log(id, "idididid", userDetails);
      let postdata = {
        token_id: [id],
      };
      let res = await authcallApi(postdata, `api/terminate-sessions`, "POST");
      if (res?.data?.success) {
        showNotification(res?.data?.message, "success");
      } else {
        showNotification(res?.data?.message, "error");
      }
    } catch (err) {
      console.log(err, "Err");
    }
  };

  useEffect(() => {
    const handleShown = (e) => setActiveCollapseId(e.target.id);
    const handleHidden = (e) => {
      if (e.target.id === activeCollapseId) {
        setActiveCollapseId(null);
      }
    };
    document.addEventListener("shown.bs.collapse", handleShown);
    document.addEventListener("hidden.bs.collapse", handleHidden);
    return () => {
      document.removeEventListener("shown.bs.collapse", handleShown);
      document.removeEventListener("hidden.bs.collapse", handleHidden);
    };
  }, [activeCollapseId]);
  const [userDetails, setUserDetails] = useState(null);
  const [tradesummary, setTradesummary] = useState();
  const userdetails = async () => {
    try {
      let res = await authcallApi({}, `api/userdetail?type=real`, "GET");
      if (res?.data?.success !== false) {
        setUserDetails(res?.data?.data);
      } else {
        console.error("API error:", res.error);
      }
    } catch (err) {
      console.log(err, "error");
    }
  };

  const gettradesummary = async () => {
    try {
      setIsRotating(true);

      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/leaderboarddetail?filter=today`,
        "GET",
      );
      if (res?.data?.success) {
        setIsRotating(false);
        setTradesummary(res?.data?.trade);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    gettradesummary();
    userdetails();
  }, [walletupdate]);
  const getamount = async (account) => {
    try {
      let postdata = {
        type: "demo",
      };
      let res = await authcallApi(postdata, `api/wallet`);
      if (res?.data?.success) {
        if (pathSegments[2] === "userdashboarddeposit") {
          setWalletprice(res?.data);
        }

        if (account === "Demo Account" && accountsetup === "Demo Account") {
          dispatch(setData(res?.data?.wallet_demo));
        } else if (account === "Live Account") {
          dispatch(setData(res?.data?.available_balance));
        }
        let available_balance_real =
          Number(res?.data?.available_balance) - Number(res?.data?.bonus);
        setTransfer((state) => ({
          ...state,
          from: {
            label: `Wallet ($${formatPrice(available_balance_real)})`,
            value: "wallet",
          },
          to: {
            label: `Safe ($${formatPrice(res?.data?.safe_balance)})`,
            value: "safe",
          },
        }));
        dispatch(setLivewallet(res?.data?.available_balance));
        setWalletamount({
          demo: res?.data?.wallet_demo ? res?.data?.wallet_demo : "0.00",
          real: res?.data?.available_balance
            ? res?.data?.available_balance
            : "0.00",
          safe: res?.data?.safe_balance ? res?.data?.safe_balance : "0.00",
          available_balance_real: available_balance_real,
          bonus: res?.data?.bonus ? res?.data?.bonus : 0,
        });
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  // useEffect(() => {

  //   getamount();
  // }, []);
  const addamount = async (amount) => {
    try {
      let postdata = { amount: amount };
      const formData = new FormData();
      for (let key in postdata) {
        if (postdata.hasOwnProperty(key)) {
          formData.append(key, postdata[key]);
        }
      }
      let res = await authcallApi(formData, `api/addwalletdemo`, "POST");
      if (res?.data?.success) {
        getamount("Demo Account");
        setShowedit(false);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const setwallet = async (value, key, checkload) => {
    try {
      let postdata = {
        key: key,
        value: value,
      };
      const formData = new FormData();
      for (let key in postdata) {
        if (postdata.hasOwnProperty(key)) {
          formData.append(key, postdata[key]);
        }
      }
      let res = await authcallApi(formData, `api/setpreference`, "POST");
      if (res?.data?.success) {
        getwallet();
        if (value === 1) {
          navigate(`${base_url}userdashboard`, {
            state: { from: "real_account" },
          });
        } else if (value === 0) {
          navigate(`${base_url}userdashboard`, {
            state: { from: "demo_account" },
          });
        }

        if (checkload) {
          window.location.reload();
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getwallet = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/preference?key=liveaccount`,
        "GET",
      );
      if (res?.data?.success) {
        if (res?.data?.value === "1") {
          setAccountsetup("Live Account");
          getamount("Live Account");
          if (pathSegments[2] === "userdashboard") {
            setCheckliveaccount(false);
          }
        } else {
          setAccountsetup("Demo Account");
          getamount("Demo Account");
          if (pathSegments[2] === "userdashboard") {
            setCheckliveaccount(true);
          }
        }
      } else {
        setAccountsetup("Demo Account");
        getamount("Demo Account");
        if (pathSegments[2] === "userdashboard") {
          setCheckliveaccount(true);
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    getwallet();
  }, []);

  const didMountRef = useRef(false);
  useEffect(() => {
    if (didMountRef.current) {
      getwallet();
    } else {
      didMountRef.current = true;
    }
  }, [walletupdate]);
  const handleClearData = () => {
    if (seriesRef?.current) {
      seriesRef.current.setData([]);
    }
  };
  const [newNotification, setNewNotification] = useState(false);
  const getnotifications = async () => {
    try {
      let postData = {};
      let res = await authcallApi(postData, `api/get-notifications`, "GET");
      if (res?.data?.success) {
        // setNotificationslist(res?.data?.data);
        getballiconlist(res?.data?.data);
        const unreadNotifications = res?.data?.data?.some(
          (notification) => !notification.read_at,
        );
        setNewNotification(unreadNotifications);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    getnotifications();
  }, [checknotifications]);
  const readnotification = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/read-notifications`, "POST");
      if (res?.data?.success) {
        setNewNotification(!res?.data?.success);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const resetdemoprice = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/resetdemoprice`, "POST");
      if (res?.data?.success) {
        getamount("Demo Account");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    const numericValue = data ? parseFloat(data.replace(/,/g, "")) : 0;
    if (isNaN(numericValue)) return;
    if (!hasMountedOnce.current) {
      hasMountedOnce.current = true;
      setDisplayAmount(numericValue);
      previousValueRef.current = numericValue;
      previousPathRef.current = location.pathname;
      return;
    }
    if (location.pathname !== previousPathRef.current) {
      previousPathRef.current = location.pathname;
      setDisplayAmount(numericValue);
      previousValueRef.current = numericValue;
      return;
    }
    if (numericValue === previousValueRef.current) return;
    previousValueRef.current = numericValue;
    const duration = 1000;
    const startValue = displayAmount;
    const endValue = numericValue;
    const startTime = performance.now();
    const animate = (currentTime) => {
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / duration, 1);
      const easedProgress =
        progress < 0.5
          ? 2 * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 2) / 2;
      const currentValue = startValue + (endValue - startValue) * easedProgress;
      setDisplayAmount(currentValue);
      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };
    requestAnimationFrame(animate);
  }, [data, location.pathname]);
  const formattedAmount = displayAmount.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const validatetransferForm = (data) => {
    const { from, amount } = data;
    const num = Number(amount);
    const maxAmount =
      from?.value === "safe"
        ? walletamount?.safe
        : walletamount?.available_balance_real;
    if (!amount) {
      return "Amount is required";
    }
    if (isNaN(num) || num < 1) {
      return "Amount must be at least 1";
    }
    if (num > maxAmount) {
      return `Amount must not be greater than ${maxAmount}`;
    }
    return "";
  };

  const handleChange = (field, value) => {
    if (field === "from") {
      setTransfer({
        ...transfer,
        from: value,
        to:
          value?.value === "safe"
            ? {
                label: `Wallet ($${formatPrice(walletamount?.available_balance_real)})`,
                value: "wallet",
              }
            : {
                label: `Safe  ($${formatPrice(walletamount?.safe)})`,
                value: "safe",
              },
        amount: "",
      });
      setError("");
    } else if (field === "amount") {
      const num = Number(value);
      // const maxAmount =
      //   transfer.from === "safe"
      //     ? Number(walletamount?.safe.replace(/,/g, ""))
      //     : Number(walletamount?.real.replace(/,/g, ""));
      // if (num < 1) {
      //   setError("Amount must be at least 1");
      // } else if (num > maxAmount) {
      //   setError(`Amount must not be greater than ${maxAmount}`);
      // } else {
      //   setError("");
      // }

      setTransfer({
        ...transfer,
        amount: value,
      });
    } else {
      setTransfer({
        ...transfer,
        [field]: value,
      });
    }
  };
  const handletransferamountSubmit = async (data) => {
    try {
      const validationError = validatetransferForm(transfer);
      if (validationError) {
        setError(validationError);
        return;
      }
      let postdata = {
        from: data?.from?.value,
        to: data?.to?.value,
        amount: data?.amount,
      };
      let res = await authcallApi(postdata, `api/safetowallet`, "POST");
      if (res?.data?.success) {
        showNotification(res?.data?.message, "success");
        getwallet();
        setTransfer({
          from: { label: "Wallet", value: "wallet" },
          to: { label: "Safe", value: "safe" },
          amount: "",
        });
      } else {
        showNotification(res?.data?.message, "error");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const updatewallet = (value) => {
    if (value === "demo_account") {
      if (accountsetup === "Demo Account") {
        setwallet(0, "liveaccount", false);
      } else {
        setwallet(0, "liveaccount", true);
      }
    } else if (value === "real_account") {
      if (accountsetup === "Live Account") {
        setwallet(1, "liveaccount", false);
      } else {
        setwallet(1, "liveaccount", true);
      }
    }
  };
  const handleToggleCollapsephoone = (collapseId) => {
    const allSubmenus = document.querySelectorAll(
      ".leftcollapsePop_main .collapse",
    );
    allSubmenus.forEach((submenu) => {
      if (submenu.id !== collapseId && submenu.classList.contains("show")) {
        const instance = window.bootstrap.Collapse.getOrCreateInstance(submenu);
        instance.hide();
      }
    });
    const targetEl = document.getElementById(collapseId);
    if (!targetEl) return;
    const targetInstance =
      window.bootstrap.Collapse.getOrCreateInstance(targetEl);
    if (targetEl.classList.contains("show")) {
      targetInstance.hide();
    } else {
      targetInstance.show();
    }
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      const collapseWrapper = document.querySelector(".leftcollapsePop_main");
      if (collapseWrapper && !collapseWrapper.contains(event.target)) {
        const openMenus = collapseWrapper.querySelectorAll(".collapse.show");
        openMenus.forEach((menu) => {
          const instance = window.bootstrap.Collapse.getOrCreateInstance(menu);
          instance.hide();
        });
      }
    };
    document.addEventListener("click", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
      document.removeEventListener("touchstart", handleOutsideClick);
    };
  }, []);
  const updatedversion = async (value) => {
    try {
      let postdata = {
        key: "mobileversion",
        value: JSON.stringify(value),
      };
      let res = await authcallApipost(postdata, `api/setpreference`, "POST");
      if (res?.data?.success) {
        window.location.reload();
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getversion = async () => {
    try {
      let res = await authcallApi(
        {},
        `api/preference?key=mobileversion`,
        "GET",
      );
      if (res?.data?.success) {
        const parsedValue = JSON.parse(res?.data.value);
        setVersion(parsedValue);
        const existingMeta = document.querySelector('meta[name="viewport"]');
        const contentValue =
          parsedValue === "1" ? "width=1410" : "width=320, initial-scale=1";
        if (existingMeta) {
          existingMeta.setAttribute("content", contentValue);
        } else {
          const meta = document.createElement("meta");
          meta.name = "viewport";
          meta.content = contentValue;
          document.head.appendChild(meta);
        }
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  useEffect(() => {
    getversion();
  }, []);
  const handleSwap = () => {
    setTransfer((prev) => ({
      from: prev.to,
      to: prev.from,
    }));
  };
  useEffect(() => {
    const newFlakes = Array.from({ length: 50 }).map(() => ({
      cx: `${getRandom(1, 100)}%`,
      cy: `-${getRandom(1, 100)}`,
      r: getRandom(1, 3),
    }));
    setFlakes(newFlakes);
  }, []);
  const getsupportlist = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/get-support-ticket?page=1&type=open`,
        "GET",
      );

        console.log("SUPPORT LIST RESPONSE:", res);
        console.log("SUPPORT LIST DATA:", res?.data);
      if (res?.data?.success) {
        if (res?.data?.data?.length) {
          let arr1 = [];
          res?.data?.data.forEach((result) => {
            if (result?.status !== "close") {
              arr1.push(result);
            }
          });
          setSupprotallcount(arr1[0]?.count);
        } else {
          setSupprotallcount(0);
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    getsupportlist();
  }, []);

  const handleScroll = () => {
    const currentScrollY = window.scrollY;

    // Show arrow after 400px scroll
    if (currentScrollY >= 400 && currentScrollY > lastScrollY) {
      setShowArrow(true);
    } else {
      setShowArrow(false);
    }

    setLastScrollY(currentScrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  // Install prompt listener
  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();

      console.log("beforeinstallprompt fired", e);

      setDeferredPrompt(e);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
    };
  }, []);

  // Show popup after prompt available
  useEffect(() => {
    if (!deferredPrompt) return;

    const now = Date.now();

    const lastShownTime = Number(localStorage.getItem("popup_last_shown")) || 0;

    const diff = (now - lastShownTime) / (1000 * 60 * 60);

    if (diff >= 12) {
      localStorage.setItem("popup_last_shown", now);

      setShowPopup(true);
    } else {
      setShowPopup(false);
    }
  }, [deferredPrompt]);

  // Install button
  const handleInstall = async () => {
    if (!deferredPrompt) {
      console.log("Install prompt not available");
      return;
    }

    deferredPrompt.prompt();

    const choiceResult = await deferredPrompt.userChoice;

    if (choiceResult.outcome === "accepted") {
      console.log("User accepted install");
    } else {
      console.log("User dismissed install");
    }

    setDeferredPrompt(null);
    setShowPopup(false);
  };

  const ScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // smooth scroll
    });
  };
  // useEffect(() => {
  //   if (localStorage.getItem("telegramJoined") === "true") {
  //     return;
  //   }
  // const hasClickedJoin =
  //   localStorage.getItem("telegramJoined") === "true";
  //   const now = Date.now();

  //   const lastShownTime = parseInt(
  //     localStorage.getItem("joinpopup_last_shown") || "0",
  //   );

  //   const diffInHours = (now - lastShownTime) / (1000 * 60 * 60);

  //   // Show once every 12 hours
  //   if (diffInHours >= 12) {
  //     localStorage.setItem("joinpopup_last_shown", now.toString());

  //     setTimeout(() => {
  //       openModal("joinUsAutoModal");
  //     }, 1000);
  //   }
  // }, []);
  useEffect(() => {
    const now = Date.now();

    const lastShownTime = parseInt(
      localStorage.getItem("joinpopup_last_shown") || "0",
    );

    const diffInDays = (now - lastShownTime) / (1000 * 60 * 60 * 24);

    const hasClickedJoin = localStorage.getItem("telegramJoined") === "true";

    // Not joined -> every 12 hours
    const shouldShow = hasClickedJoin
      ? diffInDays >= 15 // Joined -> every 15 days (~2 times/month)
      : diffInDays >= 0.5; // 12 hours

    if (shouldShow) {
      localStorage.setItem("joinpopup_last_shown", now.toString());

      setTimeout(() => {
        openModal("joinUsAutoModal");
      }, 1000);
    }
  }, []);
  const logout = () => {
    if (token) {
      terminatsessions(userDetails?.user?.token_id);
      localStorage.setItem("token", "");
      navigate(`${base_url}login`);
    }
  };
  const getballiconlist = async (notificationdata) => {
    try {
      let langcode = base_url.split("/")[1];
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/notifications?lang=${langcode}`,
        "GET",
      );
      if (res?.data?.success) {
        const apiData = res?.data?.data?.data || [];
        const localData = notificationdata || [];

        const mergedData = [...localData, ...apiData].sort((a, b) => {
          const timeA = a.created_at_timestamp
            ? Number(a.created_at_timestamp)
            : new Date(a.created_at).getTime();
          const timeB = b.created_at_timestamp
            ? Number(b.created_at_timestamp)
            : new Date(b.created_at).getTime();

          return timeB - timeA;
        });
        console.log(mergedData, "mergedData");
        setBalliconlist(mergedData);
      }
    } catch (err) {
      console.log(err, "Err");
    }
  };

  const getballiconcount = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/notifications/unread-count`,
        "GET",
      );
      if (res?.data?.success) {
        setBallcount(res?.data?.unread_count);
      }
    } catch (err) {
      console.log(err, "Err");
    }
  };
  const readballnotification = async () => {
    try {
      if (ballcount < 1) {
        return;
      }
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/notifications/read-all`,
        "POST",
      );
      if (res?.data?.success) {
        getballiconcount();
        // setBallcount(res?.data?.unread_count);
      }
    } catch (err) {
      console.log(err, "Err");
    }
  };
  const gettimezoneprefrencegettime = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/preference?key=timezoneshow`,
        "GET",
      );
      if (res?.data?.success) {
        const parsedValue = JSON.parse(res?.data.value);
        setUpdateTimezone(parsedValue);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    gettimezoneprefrencegettime();
  }, []);
  useEffect(() => {
    // getballiconlist();
    getballiconcount();
  }, []);
  return (
    <React.Fragment>
      <div
        className={`top-header popheader ${deferredPrompt && showPopup && "active"}`}
      >
        <div className="container-fluid">
          <div className="top-header-inner">
            <div className="text-box">
              <span
                className="close-btn"
                onClick={() => setDeferredPrompt(null)}
              >
                <img src={closeIcon} alt="closeIcon" />
              </span>
              <h6 className="mb-0">
                {t("Would you like to add Equlix to your home screen")}
              </h6>
            </div>

            <div className="btn-actions">
              <button
                className="site_grdbtn btn"
                onClick={() => handleInstall()}
              >
                {t("Get App")}
              </button>
            </div>
          </div>
        </div>
      </div>
      <button
        className={`scroll-arrow ${showArrow ? "show" : ""}`}
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <i className="fa-solid fa-angle-up"></i>
      </button>
      <div className="user-dashboard-header">
        {/* <svg className="svg-snowscene">
          {flakes.map((f, i) => (
            <circle key={i} cx={f.cx} cy={f.cy} r={f.r} fill="white" />
          ))}
        </svg> */}
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-12">
              <div className="user-dashboard-header-row">
                <div className="left-header-row">
                  <div className="logonavbar">
                    <button
                      className="togglemenubtn"
                      data-bs-toggle="collapse"
                      role="button"
                      aria-expanded="false"
                      aria-controls="leftmenuCollapse maindashboardCollapse"
                      onClick={() => {
                        handleToggleCollapsephoone("leftmenuCollapse");
                        handleToggleCollapsephoone("maindashboardCollapse");
                        getsupportlist();
                      }}
                    >
                      <img
                        src={
                          userDetails?.user?.image
                            ? process.env.REACT_APP_IMAGE_URL +
                              userDetails?.user?.image
                            : user
                        }
                        className="profilepopPic"
                        alt=""
                      />
                    </button>

                    <div className="site_logo">
                      <div className="christmas_santa">
                        <Link
                          to={`${base_url}userdashboard`}
                          state={{ from: "real_account" }}
                          onClick={(e) => updatewallet("real_account")}
                        >
                          {/* <img
                            className="christmas_santa_logo"
                            src={christmassantalogo}
                            alt=""
                          /> */}
                          <img src={userdashboardlogo} alt="" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  {addactivecalss?.Trading ? (
                    <div
                      className="favorite_star"
                      // data-bs-toggle="collapse"
                      // // href="#symbolSearchCollapse"
                      // role="button"
                      // aria-expanded="false"
                      // aria-controls="symbolSearchCollapse"
                      // onClick={() => {
                      //   handleToggleCollapse("symbolSearchCollapse");
                      //   showassetactive("all");
                      // }}
                      data-bs-toggle="collapse"
                      // href="#selecttradeCollapse"
                      role="button"
                      aria-expanded="false"
                      aria-controls="selecttradeCollapse"
                      onClick={() => {
                        // setOpenmodal(!openmodal);
                        handleToggleCollapse(
                          "selecttradeCollapse",
                          {},
                          false,
                          null,
                          false,
                          false,
                        );
                      }}
                    >
                      <Link to="" onClick={(e) => e.preventDefault()}>
                        <img src={Star2} alt="" />
                      </Link>
                    </div>
                  ) : (
                    ""
                  )}

                  <div className="favorite_selected_item">
                    <div className="itemListing">
                      {favorites?.length ? (
                        <div
                          style={{ position: "relative", maxWidth: "600px" }}
                        >
                          <button
                            onClick={scrollLeft}
                            style={{
                              position: "absolute",
                              top: "50%",
                              left: "8px",
                              transform: "translateY(-50%)",
                              background: "rgb(142 142 142 / 10%)",
                              border: "none",
                              borderRadius: "3px",
                              width: "18px",
                              height: "32px",
                              cursor: "pointer",
                              zIndex: 2,
                              color: "#fff",
                              backdropFilter: "blur(5px)",
                            }}
                          >
                            {"<"}
                          </button>
                          <div
                            ref={scrollContainerRef}
                            style={{
                              display: "flex",
                              overflowX: "scroll",
                              scrollBehavior: "smooth",
                              scrollbarWidth: "none",
                              msOverflowStyle: "none",
                            }}
                            className="scrollContainer"
                          >
                            {favorites?.length
                              ? favorites.map((result, key) => {
                                  return (
                                    <div
                                      // className={`${
                                      //   !parseInt(result?.status) && "d-none"
                                      // }`}
                                      className={`itemList ${
                                        selectedIndex === key ? "active" : ""
                                      } ${
                                        !parseInt(result?.status) && "d-none"
                                      }`}
                                      style={{
                                        // minWidth: "200px",
                                        margin: "0 10px",
                                      }}
                                      key={key}
                                    >
                                      <Link
                                        to=""
                                        onClick={(e) => {
                                          setshowtradeasset(
                                            result,
                                            "chartasset",
                                          );
                                          e.preventDefault();
                                        }}
                                      >
                                        <img
                                          src={
                                            process.env
                                              .REACT_APP_BASE_IMAGE_URL +
                                            result?.image
                                          }
                                          alt=""
                                        />
                                        <h5>
                                          {formatName(result?.name)}{" "}
                                          <small>FT • {result?.payout}%</small>
                                        </h5>
                                      </Link>
                                      <button
                                        type="button"
                                        className="closeBtn"
                                        onClick={() => setfavs(result, false)}
                                        style={{
                                          background: "none",
                                          border: "none",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <svg
                                          className="mt-2"
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 24 24"
                                          fill="rgba(255,255,255,1)"
                                          width="24"
                                          height="24"
                                        >
                                          <path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"></path>
                                        </svg>
                                      </button>
                                    </div>
                                  );
                                })
                              : ""}
                          </div>

                          {/* Right Arrow */}
                          <button
                            onClick={scrollRight}
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "8px",
                              transform: "translateY(-50%)",
                              background: "rgb(142 142 142 / 10%)",
                              border: "none",
                              borderRadius: "3px",
                              width: "18px",
                              height: "32px",
                              cursor: "pointer",
                              zIndex: 2,
                              color: "#fff",
                              backdropFilter: "blur(5px)",
                            }}
                          >
                            {">"}
                          </button>
                        </div>
                      ) : (
                        ""
                      )}
                      {/* <div className="itemList">
                        <Link to="">
                          <img src={eurgbpflag} alt="" />
                          <h5>
                            EUR/GBP OTC <small>FT • 80%</small>
                          </h5>
                        </Link>
                        <button type="button" className="closeBtn">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="rgba(255,255,255,1)"
                          >
                            <path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"></path>
                          </svg>
                        </button>
                      </div> */}
                    </div>
                  </div>
                </div>
                {/* <!-- -----end----- --> */}

                {/* <!-- ------start-------- --> */}
                <div className="right-header-row">
                  <div className="position-relative">
                    <div
                      className="itemList"
                      data-bs-toggle="collapse"
                      // href="#accounttradeCollapse"
                      role="button"
                      aria-expanded="false"
                      aria-controls="accounttradeCollapse"
                      onClick={() =>
                        handleToggleCollapse("accounttradeCollapse")
                      }
                    >
                      <Link
                        to=""
                        className="accountoptions"
                        onClick={(e) => e.preventDefault()}
                      >
                        <h5>
                          ${formattedAmount ? formattedAmount : "0.00"}{" "}
                          {accountsetup === "Demo Account" ? (
                            <small className="onmobileview demoac">
                              {accountsetup.substring(0, 4) + ""}
                            </small>
                          ) : (
                            <small className="onmobileview">
                              {accountsetup.substring(0, 4) + ""}
                            </small>
                          )}
                          {accountsetup === "Demo Account" ? (
                            <small className="ondesktopview demoA">
                              {t(accountsetup)}
                            </small>
                          ) : (
                            <small className="ondesktopview liveA">
                              {t(accountsetup)}
                            </small>
                          )}
                        </h5>
                        <i className="fa-solid fa-chevron-down"></i>
                      </Link>
                    </div>

                    <div
                      className="collapsePop collapse"
                      id="accounttradeCollapse"
                    >
                      <div className="accounttradeCollapse_body">
                        <h4 className="title">{t("Accounts")}</h4>
                        <div className="accountOption">
                          <div
                            className="form-check pointercursor"
                            onClick={() => {
                              setwallet(1, "liveaccount", true);
                            }}
                          >
                            <label className="form-check-label pointercursor">
                              <small>{t("Live Account")}</small>$
                              {walletamount?.real
                                ? formatPrice(walletamount?.real, 2)
                                : "0.00"}
                            </label>
                            {/* <!-- <img src="images/menu_alt.svg" className="menuicon"> --> */}
                            <input
                              className="form-check-input"
                              type="radio"
                              name="account"
                              checked={
                                accountsetup === "Live Account" ? true : false
                              }
                            />
                          </div>
                        </div>
                        <div className="accountOption ">
                          <div className="form-check pointercursor">
                            <div
                              className="pointercursorClick"
                              onClick={() => {
                                setwallet(0, "liveaccount", true);
                              }}
                            ></div>
                            <label className="form-check-label pointercursor">
                              <small>{t("Demo Account")}</small>$
                              {walletamount?.demo
                                ? formatPrice(walletamount?.demo, 2)
                                : "0.00"}
                              <a
                                onClick={() => resetdemoprice()}
                                className="mx-sm-2 px-1 py-1 z2"
                                style={{
                                  background: "none",
                                  color: "#fff",
                                  border: "1px solid",
                                  display: "inline-block",
                                  textDecoration: "none",
                                }}
                              >
                                {t("Reset")}
                              </a>
                              <div className="editformDemoAccount">
                                <input
                                  style={{
                                    backgroundColor: "#151419",
                                    color: "#fff",
                                  }}
                                  value={editamount}
                                  className={
                                    showedit ? "form-control w-100" : "d-none"
                                  }
                                  type="number"
                                  name="account"
                                  min="0"
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (
                                      value === "" ||
                                      parseFloat(value) >= 0
                                    ) {
                                      setEditamount(value);
                                    }
                                  }}
                                />
                                <button
                                  onClick={() => addamount(editamount)}
                                  className={
                                    showedit ? "btn themeBtn" : "d-none"
                                  }
                                >
                                  {t("confirm")}
                                </button>
                              </div>
                            </label>
                            <i
                              style={{ color: "#fff" }}
                              className={!showedit ? "fa-solid fa-pen z2" : ""}
                              onClick={() => setShowedit(!showedit)}
                            ></i>
                            <input
                              className="form-check-input"
                              type="radio"
                              name="account"
                              checked={
                                accountsetup === "Demo Account" ? true : false
                              }
                            />
                          </div>
                        </div>
                        <div className="accountOption ">
                          <div className="form-check pointercursor SafeWallet01">
                            <label className="form-check-label pointercursor">
                              <small>
                                {t("Safe wallet")}{" "}
                                <i
                                  onClick={() =>
                                    setShowsavewallet(!showsavewallet)
                                  }
                                  className={`toggle-password fa-regular fa-fw ${showsavewallet ? "fa-eye" : "fa-eye-slash"}`}
                                ></i>
                              </small>
                              $
                              {walletamount?.safe
                                ? showsavewallet
                                  ? formatPrice(walletamount?.safe, 2)
                                  : "*****"
                                : "0.00"}
                            </label>{" "}
                            <div>
                              <span
                                className="iconbtntype"
                                onClick={() => openModal("TransferamountModal")}
                              >
                                <i class="fa-solid fa-right-left right-left-arrow "></i>
                              </span>
                            </div>
                          </div>
                          <div className="twoBtn">
                            <Link
                              to={`${base_url}userdashboarddeposit`}
                              state={{ from: "withdrawal" }}
                              className="btn darkBtn"
                            >
                              {t("Withdraw")}
                            </Link>
                            <Link
                              className="btn themeBtn"
                              to={`${base_url}userdashboarddeposit`}
                              state={{ from: "deposit" }}
                            >
                              {t("Deposit")}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="favorite_star NotificationsCollapse ps-0 position-relative">
                    <button
                      type="button"
                      className="btnProfile position-relative"
                      data-bs-toggle="collapse"
                      aria-expanded="false"
                      aria-controls="notificationsCollapse"
                      onClick={() => {
                        handleToggleCollapse("notificationsCollapse");
                        getnotifications();
                        readnotification();
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        fill="rgba(255,255,255,1)"
                      >
                        <path d="M18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10V18H18V10ZM20 18.6667L20.4 19.2C20.5657 19.4209 20.5209 19.7343 20.3 19.9C20.2135 19.9649 20.1082 20 20 20H4C3.72386 20 3.5 19.7761 3.5 19.5C3.5 19.3918 3.53509 19.2865 3.6 19.2L4 18.6667V10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10V18.6667ZM9.5 21H14.5C14.5 22.3807 13.3807 23.5 12 23.5C10.6193 23.5 9.5 22.3807 9.5 21Z"></path>
                      </svg>
                      {newNotification ? <span></span> : ""}
                    </button>
                    <div
                      className="collapsePop collapse"
                      id="notificationsCollapse"
                      ref={collapseRef}
                    >
                      <h4 className="title">{t("Notifications")}</h4>
                      <ul className="notificationsList list-group">
                        {notificationslist?.length ? (
                          notificationslist.map((result, key) => {
                            return (
                              <li
                                className="list-group-item"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  (window.location.href =
                                    result?.notifiable_type === "Support"
                                      ? `${base_url}supportdashboard/${result?.data?.support_ticket_id}/${result?.data?.id}`
                                      : "")
                                }
                              >
                                <div className="me-auto">
                                  {result?.notifiable_type}
                                </div>
                                <lable>{result?.data?.message}</lable>
                              </li>
                            );
                          })
                        ) : (
                          <p style={{ textAlign: "center" }}>
                            {t("Notifications Not Available")}
                          </p>
                        )}
                      </ul>
                    </div>
                  </div> */}
                  <div className="favorite_star NotificationsCollapse ps-0 position-relative">
                    <button
                      type="button"
                      className="btnProfile position-relative"
                      data-bs-toggle="collapse"
                      aria-expanded="false"
                      aria-controls="balliconCollapse"
                      onClick={() => {
                        handleToggleCollapse("balliconCollapse");
                        // handleToggleCollapse("notificationsCollapse");
                        getnotifications();
                        readnotification();
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        fill="rgba(255,255,255,1)"
                      >
                        <path d="M18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10V18H18V10ZM20 18.6667L20.4 19.2C20.5657 19.4209 20.5209 19.7343 20.3 19.9C20.2135 19.9649 20.1082 20 20 20H4C3.72386 20 3.5 19.7761 3.5 19.5C3.5 19.3918 3.53509 19.2865 3.6 19.2L4 18.6667V10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10V18.6667ZM9.5 21H14.5C14.5 22.3807 13.3807 23.5 12 23.5C10.6193 23.5 9.5 22.3807 9.5 21Z"></path>
                      </svg>
                               {newNotification ||ballcount > 0 ? <span></span> : ""}
                      {/* {ballcount > 0 ? (
                        ballcount > 99 ? (
                          <span className="notification-count">99+</span>
                        ) : (
                          <span className="notification-count">
                            {ballcount}
                          </span>
                        )
                      ) : (
                        ""
                      )} */}
                    </button>
                  
                  </div>
                  <Link
                    to={`${base_url}userdashboarddeposit`}
                    state={{ from: "deposit" }}
                    className="btn depositBtn"
                    onClick={() => {
                      handleClearData();
                      handleToggleCollapse("leftmenuCollapse");
                    }}
                  >
                    {t("Deposit")}
                  </Link>

                  <div className="favorite_star profileCollapse ps-0 position-relative mob-none">
                    <button
                      // role="button"
                      type="button"
                      className="btnProfile collapsed"
                      data-bs-toggle="collapse"
                      aria-expanded="false"
                      aria-controls="profileCollapse"
                      onClick={() => handleToggleCollapse("profileCollapse")}
                    >
                      {userDetails?.user?.image ? (
                        <img
                          src={
                            process.env.REACT_APP_IMAGE_URL +
                            userDetails.user.image
                          }
                          className="profilepopPic"
                          alt="profile"
                        />
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width="24"
                          height="24"
                          fill="rgba(255,255,255,1)"
                        >
                          <path d="M4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22H18C18 18.6863 15.3137 16 12 16C8.68629 16 6 18.6863 6 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11Z"></path>
                        </svg>
                      )}
                    </button>
                    <div
                      className={`collapsePop collapse sdSs`}
                      id="profileCollapse"
                      // style={{ minWidth: "600px" }}
                    >
                      <div className="profileCollapsetapmenu">
                        <div className="user-popup-info">
                          <div className="profileCollapsepop">
                            <img
                              src={
                                userDetails?.user?.image
                                  ? process.env.REACT_APP_IMAGE_URL +
                                    userDetails?.user?.image
                                  : user
                              }
                              className="profilepopPic"
                              alt=""
                            />
                            <div className="profileDtls">
                              <p>
                                {userDetails?.user?.name
                                  ? formatName(userDetails?.user?.name)
                                  : ""}
                              </p>
                              <p>
                                <i className="fa-solid fa-user"></i> id{" "}
                                {userDetails?.user?.id
                                  ? userDetails?.user?.id
                                  : ""}
                                <svg
                                  onClick={() =>
                                    handleCopy(userDetails?.user?.id)
                                  }
                                  style={{ cursor: "pointer" }}
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  width="13"
                                  height="13"
                                  fill="rgba(255,255,255,1)"
                                >
                                  <path d="M6.9998 6V3C6.9998 2.44772 7.44752 2 7.9998 2H19.9998C20.5521 2 20.9998 2.44772 20.9998 3V17C20.9998 17.5523 20.5521 18 19.9998 18H16.9998V20.9991C16.9998 21.5519 16.5499 22 15.993 22H4.00666C3.45059 22 3 21.5554 3 20.9991L3.0026 7.00087C3.0027 6.44811 3.45264 6 4.00942 6H6.9998ZM5.00242 8L5.00019 20H14.9998V8H5.00242ZM8.9998 6H16.9998V16H18.9998V4H8.9998V6Z"></path>
                                </svg>
                              </p>
                              <p>
                                <i className="fa-solid fa-envelope"></i>{" "}
                                {userDetails?.user?.email
                                  ? (() => {
                                      const email = userDetails.user.email;
                                      const [name, domain] = email.split("@");
                                      const visiblePart = name.slice(0, 7);
                                      const [domainsplit, comshow] =
                                        domain.split(".");
                                      const domainsplitvidible =
                                        domainsplit.slice(0, 6);
                                      return `${visiblePart}...@${domainsplitvidible}.${comshow}`;
                                    })()
                                  : ""}
                              </p>
                              <p>
                                <i className="fa-solid fa-wallet"></i> $
                                {formatPrice(userDetails?.user?.balance, 2)}
                              </p>
                            </div>
                          </div>
                          <ol className="list-group mt-4">
                            <li className="list-group-item d-flex justify-content-between align-items-start">
                              <div className="ms-2 me-auto">
                                <strong>
                                  {t("Real account statistics for today:")}
                                </strong>
                              </div>

                              <span
                                className="badge"
                                onClick={() => gettradesummary()}
                              >
                                <i
                                  className="fa-solid fa-rotate-right"
                                  style={{
                                    transition: "transform 1s linear",
                                    transform: isRotating
                                      ? "rotate(360deg)"
                                      : "",
                                  }}
                                ></i>
                              </span>
                            </li>
                            <li className="list-group-item d-flex justify-content-between align-items-start">
                              <div className="ms-2 me-auto">{t("Trades")}:</div>
                              <span className="badge">
                                {tradesummary?.trades_count
                                  ? tradesummary?.trades_count
                                  : "0"}
                              </span>
                            </li>
                            <li className="list-group-item d-flex justify-content-between align-items-start">
                              <div className="ms-2 me-auto">
                                {t("Trading turnover:")}
                              </div>
                              <span className="badge">
                                $
                                {tradesummary?.trading_turnover
                                  ? tradesummary?.trading_turnover
                                  : "0.00"}
                              </span>
                            </li>
                            {/* <li className="list-group-item d-flex justify-content-between align-items-start">
                              <div className="ms-2 me-auto">
                                {t("Net turnover:")}
                              </div>
                              <span className="badge">
                                {tradesummary?.net_turnover
                                  ? tradesummary?.net_turnover
                                  : 0}
                              </span>
                            </li> */}
                            <li className="list-group-item d-flex justify-content-between align-items-start">
                              <div className="ms-2 me-auto">
                                {t("Trading profit:")}
                              </div>
                              <span className="badge">
                                $
                                {tradesummary?.trades_profit
                                  ? tradesummary?.trades_profit
                                  : "0.00"}
                              </span>
                            </li>
                          </ol>
                          <ul className="nav-links w-100 mt-3">
                            <li>
                              <Link
                                to={`${base_url}accounthistory`}
                                className="w-100"
                                state={{ from: "analytics" }}
                                onClick={() => handleClearData()}
                              >
                                {t("Real account overall statistics")}{" "}
                                <i className="fa-solid fa-angles-right"></i>
                              </Link>
                            </li>
                          </ul>
                        </div>

                        <ul className="nav-links rightcoltap">
                          <li>
                            <Link
                              to={`${base_url}accounthistory`}
                              state={{ from: "profile" }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="24"
                                height="24"
                                fill="rgba(255,255,255,1)"
                              >
                                <path d="M4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22H18C18 18.6863 15.3137 16 12 16C8.68629 16 6 18.6863 6 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11Z"></path>
                              </svg>
                              {t("Profile")}
                            </Link>
                          </li>

                          <li>
                            <Link
                              to={`${base_url}userdashboarddeposit`}
                              state={{ from: "deposit" }}
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M15.033 11.2917C14.683 11.6334 14.483 12.125 14.533 12.65C14.608 13.55 15.433 14.2084 16.333 14.2084H17.9163V15.2C17.9163 16.925 16.508 18.3334 14.783 18.3334H5.21634C3.49134 18.3334 2.08301 16.925 2.08301 15.2V9.59172C2.08301 7.86672 3.49134 6.45837 5.21634 6.45837H14.783C16.508 6.45837 17.9163 7.86672 17.9163 9.59172V10.7917H16.233C15.7663 10.7917 15.3413 10.975 15.033 11.2917Z"
                                  stroke="white"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                ></path>
                                <path
                                  d="M2.08301 10.3417V6.53342C2.08301 5.54175 2.69134 4.65838 3.61634 4.30838L10.233 1.80838C11.2663 1.41672 12.3747 2.18341 12.3747 3.29174V6.4584"
                                  stroke="white"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                ></path>
                                <path
                                  d="M18.7987 11.6418V13.3586C18.7987 13.8169 18.432 14.1918 17.9653 14.2085H16.332C15.432 14.2085 14.607 13.5502 14.532 12.6502C14.482 12.1252 14.682 11.6335 15.032 11.2918C15.3404 10.9752 15.7653 10.7919 16.232 10.7919H17.9653C18.432 10.8085 18.7987 11.1835 18.7987 11.6418Z"
                                  stroke="white"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                ></path>
                                <path
                                  d="M5.83301 10H11.6663"
                                  stroke="white"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                ></path>
                              </svg>
                              {t("Deposit")}
                            </Link>
                          </li>

                          <li>
                            <Link
                              to={`${base_url}userdashboarddeposit`}
                              state={{ from: "withdrawal" }}
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.91699 11.4583C7.91699 12.2666 8.542 12.9166 9.30867 12.9166H10.8753C11.542 12.9166 12.0837 12.3499 12.0837 11.6416C12.0837 10.8833 11.7503 10.6083 11.2587 10.4333L8.75033 9.55828C8.25866 9.38328 7.92533 9.11662 7.92533 8.34995C7.92533 7.64995 8.46699 7.07495 9.13365 7.07495H10.7003C11.467 7.07495 12.092 7.72495 12.092 8.53328"
                                  stroke="white"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                ></path>
                                <path
                                  d="M10 6.25V13.75"
                                  stroke="white"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                ></path>
                                <path
                                  d="M18.3337 9.99996C18.3337 14.6 14.6003 18.3333 10.0003 18.3333C5.40033 18.3333 1.66699 14.6 1.66699 9.99996C1.66699 5.39996 5.40033 1.66663 10.0003 1.66663"
                                  stroke="white"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                ></path>
                                <path
                                  d="M14.167 2.5V5.83333H17.5003"
                                  stroke="white"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                ></path>
                                <path
                                  d="M18.3337 1.66663L14.167 5.83329"
                                  stroke="white"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                ></path>
                              </svg>
                              {t("Withdrawal")}
                            </Link>
                          </li>

                          <li>
                            <Link
                              to={`${base_url}supportdashboard`}
                              state={{ from: "my_requests" }}
                            >
                              <img src={dashlefticon05} alt="" />
                              {t("Support")}
                            </Link>
                          </li>
                          <li>
                            <Link to={`${base_url}setting`}>
                              <i className="fa-solid fa-gear"></i>
                              {t("Settings")}
                            </Link>
                          </li>
                          <li className="">
                            <div className="dropdownLanguages">
                              <svg
                                width="25"
                                height="24"
                                viewBox="0 0 25 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M13.3982 17H20.4564M13.3982 17L11.516 21M13.3982 17L16.2172 11.009C16.4444 10.5263 16.5579 10.2849 16.7133 10.2086C16.8485 10.1423 17.006 10.1423 17.1412 10.2086C17.2966 10.2849 17.4102 10.5263 17.6373 11.009L20.4564 17M20.4564 17L22.3386 21M2.66113 5H8.56436M8.56436 5H12.0079M8.56436 5V3M12.0079 5H14.4676M12.0079 5C11.5198 7.95729 10.3871 10.6362 8.72724 12.8844M10.5321 14C9.92945 13.7248 9.31471 13.3421 8.72724 12.8844M8.72724 12.8844C7.39652 11.8478 6.20579 10.4266 5.61275 9M8.72724 12.8844C7.14843 15.0229 5.09271 16.7718 2.66113 18"
                                  stroke="white"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                ></path>
                              </svg>
                              <LanguageSelector />
                            </div>
                          </li>
                          <li
                            onClick={() => {
                              logout();
                              handleClearData();
                            }}
                          >
                            <Link>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 640 640"
                              >
                                <path d="M224 160C241.7 160 256 145.7 256 128C256 110.3 241.7 96 224 96L160 96C107 96 64 139 64 192L64 448C64 501 107 544 160 544L224 544C241.7 544 256 529.7 256 512C256 494.3 241.7 480 224 480L160 480C142.3 480 128 465.7 128 448L128 192C128 174.3 142.3 160 160 160L224 160zM566.6 342.6C579.1 330.1 579.1 309.8 566.6 297.3L438.6 169.3C426.1 156.8 405.8 156.8 393.3 169.3C380.8 181.8 380.8 202.1 393.3 214.6L466.7 288L256 288C238.3 288 224 302.3 224 320C224 337.7 238.3 352 256 352L466.7 352L393.3 425.4C380.8 437.9 380.8 458.2 393.3 470.7C405.8 483.2 426.1 483.2 438.6 470.7L566.6 342.7z" />
                              </svg>
                              {t("Logout")}{" "}
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <!-- --------end-------- --> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* left header end */}
      {/* left sidebar start */}
      <div className="leftnavmenu collapse" id="leftmenuCollapse">
        <button
          className="togglemenubtn"
          data-bs-toggle="collapse"
          role="button"
          aria-expanded="false"
          aria-controls="leftmenuCollapse"
          onClick={() => handleToggleCollapse("leftmenuCollapse")}
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
        <div className="leftnavmenu-body">
          <div className="profileCollapsepop sidebar-mobile-profile">
            <img
              src={
                userDetails?.user?.image
                  ? process.env.REACT_APP_IMAGE_URL + userDetails?.user?.image
                  : user
              }
              className="profilepopPic"
              alt=""
            />
            <div className="profileDtls">
              <p className="username01">
                {userDetails?.user?.name
                  ? formatName(userDetails?.user?.name)
                  : ""}
              </p>
              <p>
                <i className="fa-solid fa-user"></i> id{" "}
                {userDetails?.user?.id ? userDetails?.user?.id : ""}
                <svg
                  onClick={() => handleCopy(userDetails?.user?.id)}
                  style={{ cursor: "pointer" }}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="13"
                  height="13"
                  fill="rgba(255,255,255,1)"
                >
                  <path d="M6.9998 6V3C6.9998 2.44772 7.44752 2 7.9998 2H19.9998C20.5521 2 20.9998 2.44772 20.9998 3V17C20.9998 17.5523 20.5521 18 19.9998 18H16.9998V20.9991C16.9998 21.5519 16.5499 22 15.993 22H4.00666C3.45059 22 3 21.5554 3 20.9991L3.0026 7.00087C3.0027 6.44811 3.45264 6 4.00942 6H6.9998ZM5.00242 8L5.00019 20H14.9998V8H5.00242ZM8.9998 6H16.9998V16H18.9998V4H8.9998V6Z"></path>
                </svg>
              </p>
              <p>
                <i className="fa-solid fa-envelope"></i>{" "}
                {userDetails?.user?.email
                  ? (() => {
                      const email = userDetails.user.email;
                      const [name, domain] = email.split("@");
                      const visiblePart = name.slice(0, 5);
                      const [domainsplit, comshow] = domain.split(".");
                      const domainsplitvidible = domainsplit.slice(0, 8);
                      return `${visiblePart}...@${domainsplitvidible}.${comshow}`;
                    })()
                  : ""}
              </p>
              <p>
                <i className="fa-solid fa-wallet"></i> $
                {formatPrice(userDetails?.user?.balance, 2)}
              </p>
            </div>
          </div>
          <Link
            to={`${base_url}userdashboarddeposit`}
            state={{ from: "deposit" }}
            className="btn depositBtn"
            onClick={() => {
              handleClearData();
              handleToggleCollapse("leftmenuCollapse");
            }}
          >
            {t("Deposit")}
          </Link>
          <ul className="navmenu">
            {/* <li
              className={`menu-link ${addactivecalss?.Trading ? "active" : ""}`}
            >
              <Link
                to={`${base_url}userdashboard`}
                onClick={() => {
                  handleClearData();
                  handleToggleCollapse("leftmenuCollapse");
                }}
              >
                <span className="iconShap">
                  <img src={dashlefticon01} alt="" />
                </span>{" "}
                {t("Trading")}
              </Link>
            </li>
            <li
              className={`menu-link ${addactivecalss?.Finance ? "active" : ""}`}
            >
              <Link
                to={`${base_url}userdashboarddeposit`}
                onClick={() => {
                  handleClearData();
                  handleToggleCollapse("leftmenuCollapse");
                }}
              >
                <span className="iconShap">
                  <img src={dashlefticon02} alt="" />
                </span>{" "}
                {t("Finance")}
              </Link>
            </li>
            <li
              className={`menu-link ${addactivecalss?.Profile ? "active" : ""}`}
            >
              <Link
                to={`${base_url}accounthistory`}
                onClick={() => {
                  handleClearData();
                  handleToggleCollapse("leftmenuCollapse");
                }}
              >
                <span className="iconShap">
                  <img src={dashlefticon04} alt="" />
                </span>{" "}
                {t("Profile")}
              </Link>
            </li>
            <li
              className={`menu-link ${
                addactivecalss?.Analytics ? "active" : ""
              }`}
              onClick={() => {
                handleClearData();
                handleToggleCollapse("leftmenuCollapse");
              }}
            >
              <Link to={`${base_url}analytics`}>
                <span className="iconShap">
                  <img src={dashrighticon02} alt="" />
                </span>{" "}
                {t("Analytics")}
              </Link>
            </li>
            <li
              className={`menu-link ${addactivecalss?.Market ? "active" : ""}`}
              onClick={() => {
                handleClearData();
                handleToggleCollapse("leftmenuCollapse");
              }}
            >
              <Link to={`${base_url}marketdashboard`}>
                <span className="iconShap">
                  <img src={dashlefticon03} alt="" />
                </span>{" "}
                {t("Market")}
              </Link>
            </li>
            <li
              className={`menu-link ${addactivecalss?.Support ? "active" : ""}`}
            >
              <Link
                to={`${base_url}supportdashboard`}
                onClick={() => {
                  handleClearData();
                  handleToggleCollapse("leftmenuCollapse");
                }}
              >
                <span className="iconShap">
                  <img src={dashlefticon05} alt="" />
                </span>{" "}
                {t("Support")}
              </Link>
            </li> */}

            <li
              className={`menu-link ${
                addactivecalss?.Trading
                  ? "active"
                  : activeCollapseId === "tradingTabCollapse" && "show_submenu"
              }`}
            >
              <Link
                role="button"
                // type="button"
                className="btnProfile collapsed"
                data-bs-toggle="collapse"
                aria-expanded="false"
                aria-controls="supportTabCollapse"
                onClick={() => handleToggleCollapsephoone("tradingTabCollapse")}
              >
                <span className="iconShap">
                  <img src={dashlefticon01} alt="" />
                </span>{" "}
                {t("Trading")}
              </Link>
            </li>
            <li
              className={`menu-link ${
                addactivecalss?.Finance
                  ? "active"
                  : activeCollapseId === "financeTabCollapse" && "show_submenu"
              }`}
            >
              <Link
                role="button"
                // type="button"
                className="btnProfile collapsed"
                data-bs-toggle="collapse"
                aria-expanded="false"
                aria-controls="supportTabCollapse"
                onClick={() => handleToggleCollapsephoone("financeTabCollapse")}
              >
                <span className="iconShap">
                  <img src={dashlefticon02} alt="" />
                </span>{" "}
                {t("Finance")}
              </Link>
            </li>
            <li
              className={`menu-link ${
                addactivecalss?.Profile
                  ? "active"
                  : activeCollapseId === "profileTabCollapse" && "show_submenu"
              }`}
            >
              <Link
                role="button"
                // type="button"
                className="btnProfile collapsed"
                data-bs-toggle="collapse"
                aria-expanded="false"
                aria-controls="supportTabCollapse"
                onClick={() => handleToggleCollapsephoone("profileTabCollapse")}
              >
                <span className="iconShap">
                  <img src={dashlefticon04} alt="" />
                </span>{" "}
                {t("Profile")}
              </Link>
            </li>
            <li
              className={`menu-link ${
                addactivecalss?.Analytics ? "active" : ""
              }`}
              onClick={() => {
                handleClearData();
                handleToggleCollapse("leftmenuCollapse");
                ScrollToTop();
              }}
            >
              <Link to={`${base_url}analytics`}>
                <span className="iconShap">
                  <img src={dashrighticon02} alt="" />
                </span>{" "}
                {t("Analytics")}
              </Link>
            </li>
            <li
              className={`menu-link  ${
                addactivecalss?.Market
                  ? "active"
                  : activeCollapseId === "marketTabCollapse" && "show_submenu"
              }`}
            >
              <Link
                role="button"
                // type="button"
                className="btnProfile collapsed"
                data-bs-toggle="collapse"
                aria-expanded="false"
                aria-controls="supportTabCollapse"
                onClick={() => handleToggleCollapsephoone("marketTabCollapse")}
              >
                <span className="iconShap">
                  <img src={dashlefticon03} alt="" />
                </span>{" "}
                {t("Market")}
              </Link>
            </li>
            <li
              className={`menu-link ${
                addactivecalss?.Support
                  ? "active"
                  : activeCollapseId === "supportTabCollapse" && "show_submenu"
              }`}
            >
              <Link
                role="button"
                // type="button"
                className="btnProfile collapsed"
                data-bs-toggle="collapse"
                aria-expanded="false"
                aria-controls="supportTabCollapse"
                onClick={() => {
                  handleToggleCollapsephoone("supportTabCollapse");
                  getsupportlist();
                }}
              >
                <span className="iconShap">
                  <img src={dashlefticon05} alt="" />
                </span>{" "}
                {t("Support")}
                {supportallcount > 0 ? (
                  <div className="sidebarcountmenu">{supportallcount}</div>
                ) : (
                  ""
                )}
              </Link>
            </li>

            <li className="menu-link mobile-link desktop-none mobi-block">
              <div className="dropdownLanguages">
                <span className="iconShap">
                  <span class="iconShap">
                    <svg
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.3982 17H20.4564M13.3982 17L11.516 21M13.3982 17L16.2172 11.009C16.4444 10.5263 16.5579 10.2849 16.7133 10.2086C16.8485 10.1423 17.006 10.1423 17.1412 10.2086C17.2966 10.2849 17.4102 10.5263 17.6373 11.009L20.4564 17M20.4564 17L22.3386 21M2.66113 5H8.56436M8.56436 5H12.0079M8.56436 5V3M12.0079 5H14.4676M12.0079 5C11.5198 7.95729 10.3871 10.6362 8.72724 12.8844M10.5321 14C9.92945 13.7248 9.31471 13.3421 8.72724 12.8844M8.72724 12.8844C7.39652 11.8478 6.20579 10.4266 5.61275 9M8.72724 12.8844C7.14843 15.0229 5.09271 16.7718 2.66113 18"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </span>
                </span>

                <LanguageSelector />
              </div>
            </li>

            <li
              className="menu-link mobile-link desktop-none mobi-block Settings_tabLink"
              onClick={() => {
                handleClearData();
                handleToggleCollapse("leftmenuCollapse");
              }}
            >
              <Link
                to={`${base_url}setting`}
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title={t("Settings")}
              >
                <span className="iconShap">
                  <i className="fa-solid fa-gear"></i>
                </span>{" "}
                {t("Settings")}
              </Link>
            </li>

            {/* Screen view start */}
            {version === "1" ? (
              <li className="menu-link mobileVersionBtn">
                <div
                  type="button"
                  rel="noreferrer"
                  onClick={() => updatedversion("0")}
                >
                  <span className="iconShap">
                    <i class="fa-solid fa-tablet-screen-button"></i>
                  </span>{" "}
                  {t("Mobile version")}
                </div>
              </li>
            ) : (
              <li className="menu-link desktopVersionBtn mobile-link desktop-none mobi-block">
                <div
                  type="button"
                  rel="noreferrer"
                  onClick={() => updatedversion("1")}
                >
                  <span className="iconShap">
                    <i class="fa-solid fa-desktop"></i>
                  </span>{" "}
                  {t("Desktop version")}
                </div>
              </li>
            )}
            {/* Screen view end */}

            <li className="menu-link mobile-link desktop-none mobi-block">
              <a
                href="https://t.me/EqulixOfficial"
                target="_blank"
                rel="noreferrer"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                data-bs-original-title="Telegram"
              >
                <span className="iconShap">
                  <img src={telegram2line} alt="" />
                </span>{" "}
                {t("Official")}
              </a>
            </li>
            <li
              className="menu-link mobile-link desktop-none mobi-block"
              onClick={() => {
                logout();
                handleClearData();
              }}
            >
              <Link className="">
                <span className="iconShap">
                  <i className="fa-solid fa-arrow-right-from-bracket"></i>
                </span>
                {t("Logout")}{" "}
              </Link>
            </li>
          </ul>
          <ul className="navmenu">
            <li className="menu-link">
              <ul className="settingsOPtion01">
                <li
                  className="menu-link"
                  onClick={() => {
                    isFullScreen ? exitFullScreen() : enterFullScreen();
                  }}
                >
                  <Link
                    to=""
                    onClick={(e) => e.preventDefault()}
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title={t("Full Screen")}
                  >
                    <i className="fa-solid fa-expand"></i>
                  </Link>
                </li>
                {/* <li className="menu-link thememode">
                  <Link
                    to=""
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title={t("Night Mode")}
                  >
                    <i className="fa-regular fa-moon"></i>
                  </Link>
                </li> */}
                <li className="menu-link" onClick={() => handleClearData()}>
                  <Link
                    to={`${base_url}setting`}
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title={t("Settings")}
                  >
                    <i className="fa-solid fa-gear"></i>
                  </Link>
                </li>
                {/* <!-- <li className="menu-link"><a href="support-dashboard.php" data-bs-toggle="tooltip" data-bs-placement="top" title="Support"><i className="fa-solid fa-question"></i></a></li> --> */}
                <li
                  onClick={() => openModal("joinUsModal")}
                  // onClick={() => openModal("joinUsAutoModal")}
                  className="menu-link"
                  // data-bs-toggle="modal"
                  // data-bs-target="#joinUsModal"
                >
                  <button
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title={t("Join Us")}
                  >
                    <img src={partnership} alt="" />
                  </button>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div className="leftcollapsePop_main">
          {Sidebartabs.map((section) => {
            const collapseId = `${section.key.toLowerCase()}TabCollapse`;
            return (
              <div
                key={section.key}
                className={`leftcollapsePop collapsePop collapse`}
                id={collapseId}
              >
                <div className="innerDiv">
                  <h5
                    role="button"
                    className="backleftcollapsebtn collapsed"
                    data-bs-toggle="collapse"
                    aria-expanded="false"
                    aria-controls={`${section.key.toLowerCase()}TabCollapse`}
                    onClick={() =>
                      handleToggleCollapsephoone(
                        `${section.key.toLowerCase()}TabCollapse`,
                      )
                    }
                  >
                    <i className="fa-solid fa-arrow-left"></i> Back
                  </h5>

                  <ul className="leftcollapsetabList">
                    {section.key === "Market" ? (
                      <p className="text-danger text-center">
                        {t("Currently not available")}
                      </p>
                    ) : (
                      ""
                    )}
                    {section.items.map((item, idx) => {
                      const isActive =
                        location.pathname ===
                          `${base_url}${section?.linkurl}` &&
                        location.state?.from === item?.value;

                      return (
                        section.key !== "Market" && (
                          <li key={idx} onClick={() => ScrollToTop()}>
                            <Link
                              className={`nav-link ${isActive ? "active" : ""}`}
                              type="button"
                              role="tab"
                              to={`${base_url}${section?.linkurl}`}
                              state={{ from: item?.value }}
                              onClick={() => {
                                if (
                                  item?.value === "demo_account" ||
                                  item?.value === "real_account"
                                ) {
                                  updatewallet(item?.value);
                                }
                                handleToggleCollapsephoone(
                                  `${section.key.toLowerCase()}TabCollapse`,
                                );
                                handleToggleCollapse("leftmenuCollapse");
                              }}
                            >
                              <span
                                dangerouslySetInnerHTML={{ __html: item.icon }}
                              />
                              {t(item.name)}
                              {item?.value === "my_requests" ? (
                                supportallcount > 0 ? (
                                  <div className="sidebarcountmenu">
                                    {supportallcount}
                                  </div>
                                ) : (
                                  ""
                                )
                              ) : (
                                ""
                              )}
                            </Link>
                          </li>
                        )
                      );
                    })}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {/* left sidebar end */}
      {/* Join Us Auto Modal start */}
      <div
        ref={(el) => (modalRefs.current["joinUsAutoModal"] = el)}
        className="modal fade"
        id="joinUsAutoModal"
        tabindex="-1"
        aria-labelledby="joinUsAutoModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>

              <div className="joinautopopup">
                <div className="joinLeft0">
                  <h5 className="modal-title mb-3">
                    <i class="fa-brands fa-telegram"></i> {t("Join Us!")}
                  </h5>
                  <div className="pb-3">
                    <Link
                      onClick={() => {
                        localStorage.setItem("telegramJoined", "true");
                      }}
                      style={{ textDecoration: "none" }}
                      to="https://t.me/EqulixOfficial"
                      target="_blank"
                    >
                      @EqulixOfficial
                    </Link>
                  </div>
                  <h6 className="text-white mb-0">
                    {t("Subscribe to our official Telegram channel.")}
                  </h6>
                </div>
                <img src={telegramChart} alt="Telegram" />
              </div>

              <div className="btnsFull">
                <Link
                  onClick={() => {
                    localStorage.setItem("telegramJoined", "true");
                  }}
                  style={{ textDecoration: "none" }}
                  to="https://t.me/EqulixOfficial"
                  target="_blank"
                  type="button"
                  class="btn bg_btn w-100 justify-content-center"
                >
                  <i class="fa-solid fa-check"></i> Join now
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Join Us Auto Modal end */}
      {/* Join Us Modal start */}
      <div
        ref={(el) => (modalRefs.current["joinUsModal"] = el)}
        className="modal fade"
        id="joinUsModal"
        tabindex="-1"
        aria-labelledby="joinUsModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <h5 className="modal-title">
                {t("Connect with Us Across Social Networks!")}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
              <p>
                {t(
                  "Don't miss out on the latest news, offers, and insights! Join our social networks today to stay informed and connected. Get exclusive updates delivered straight to your feed and be the first to hear about exciting developments in our company.",
                )}
              </p>
              <div className="btnsGroup">
                <h5 className="title">{t("Follow us")}</h5>
                <div>
                  <Link
                    className="btn dark_btn facebookbtn"
                    to="https://www.facebook.com/equlixofficial/"
                    target="_blank"
                  >
                    <img src={facebook} alt="facebook.png" />
                    {t("Facebook")}
                  </Link>
                  <Link
                    onClick={() => handleClearData()}
                    className="btn dark_btn instagrambtn"
                    to="https://www.instagram.com/equlixofficial/"
                    target="_blank"
                  >
                    <img src={instagram} alt="instagram.png" />
                    {t("Instagram")}
                  </Link>
                  <Link
                    onClick={() => handleClearData()}
                    className="btn dark_btn telegrambtn"
                    to="https://t.me/EqulixOfficial"
                    target="_blank"
                  >
                    <img src={telegram} alt="telegram.png" />
                    {t("Telegram")}
                  </Link>
                  <Link
                    onClick={() => handleClearData()}
                    className="btn dark_btn youtubebtn"
                    to="https://youtube.com/@equlixofficial?si=3LXOjCNLS3EtuXO6"
                    target="_blank"
                  >
                    <img src={youtube} alt="youtube.png" />
                    {t("Youtube")}
                  </Link>
                  <Link
                    onClick={() => handleClearData()}
                    className="btn dark_btn twitterbtn"
                    to="https://x.com/EqulixOfficial"
                    target="_blank"
                  >
                    <img src={twitter} alt="twitter.png" />
                    {t("Twitter")}
                  </Link>
                  <Link
                    onClick={() => handleClearData()}
                    className="btn dark_btn telegrambtn"
                    to="https://vk.com/equlix"
                    target="_blank"
                  >
                    <i className="fa-brands fa-vk"></i>
                    {t("VK")}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Join Us Modal end */}
      {/* transfer payment modal */}
      <div
        ref={(el) => (modalRefs.current["TransferamountModal"] = el)}
        className="modal fade"
        id="TransferamountModal"
        tabindex="-1"
        aria-labelledby="joinUsModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <h5 className="modal-title mb-3 text-center">
                {t("Transfer amount")}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>

              <div className="">
                <form action="#" className="withdrawal_form">
                  <div className="row">
                    {/* From */}
                    <div className="col-12 oppositearrowoption">
                      <div className="formoption">
                        <label>{t("From")}</label>
                        <CommonDropdown
                          label={transfer.from?.label}
                          options={[
                            {
                              label: `Safe ($${formatPrice(
                                walletamount?.safe,
                              )})`,
                              value: "safe",
                            },
                            {
                              label: `Wallet ($${formatPrice(
                                walletamount?.available_balance_real,
                              )})`,
                              value: "wallet",
                            },
                          ]}
                          onSelect={(val) => handleChange("from", val)}
                          labelKey="label"
                        />
                        {/* <select
                          className="form-select form-control"
                          value={transfer.from}
                          onChange={(e) => handleChange("from", e.target.value)}
                        >
                          <option value="safe">Safe</option>
                          <option value="wallet">Wallet</option>
                        </select> */}
                      </div>
                      <div
                        className="oppositearrowbtn"
                        onClick={() => handleSwap()}
                      >
                        <img src={oppositearrow} alt="" />
                      </div>
                      {/* To */}
                      <div className="formoption">
                        <label>{t("To")}</label>
                        <CommonDropdown
                          label={transfer.to?.label}
                          options={[
                            {
                              label: `Safe ($${formatPrice(
                                walletamount?.safe,
                              )})`,
                              value: "safe",
                            },
                            {
                              label: `Wallet ($${formatPrice(
                                walletamount?.available_balance_real,
                              )})`,
                              value: "wallet",
                            },
                          ]}
                          onSelect={(val) => handleChange("to", val)}
                          labelKey="label"
                          disabled={true}
                        />
                        {/* <select
                          className="form-select form-control"
                          value={transfer.to}
                          onChange={(e) => handleChange("to", e.target.value)}
                        >
                          <option
                            value="safe"
                            disabled={transfer.from === "safe"}
                          >
                            Safe
                          </option>
                          <option
                            value="wallet"
                            disabled={transfer.from === "wallet"}
                          >
                            Wallet
                          </option>
                        </select> */}
                      </div>
                    </div>

                    {/* Amount */}
                    <div className="col-lg-12">
                      <div className="mb-3">
                        <label>{t("Amount")} </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter amount"
                          value={
                            transfer.amount
                              ? formatPricewithdesimal(transfer.amount, 2)
                              : ""
                          }
                          onChange={(e) => {
                            let value = e.target.value.replace(/,/g, "");

                            // only numbers + one decimal
                            if (/^\d*\.?\d*$/.test(value)) {
                              handleChange("amount", value);
                            }
                          }}
                          onBlur={() => {
                            const maxAmount =
                              transfer.from?.value === "safe"
                                ? Number(
                                    walletamount?.safe.replace(/,/g, ""),
                                  ) || 0
                                : Number(
                                    walletamount?.available_balance_real,
                                  ) || 0;

                            if (Number(transfer.amount) > maxAmount) {
                              handleChange("amount", maxAmount.toString());
                            }
                          }}
                        />
                        {error && (
                          <small className="text-danger">{error}</small>
                        )}
                      </div>
                    </div>
                    {Number(walletamount?.bonus) > 0 ? (
                      <div className="alertBox">
                        <div className="alert alert-danger">
                          <ul>
                            <li>
                              Moving money from wallet to safe money will
                              deactivate your bonus.
                            </li>
                          </ul>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {/* Button */}
                    <div className="col-12">
                      <button
                        type="button"
                        className="btn bg-white m-0"
                        // disabled={!error || !transfer?.amount}
                        onClick={() => handletransferamountSubmit(transfer)}
                      >
                        {t("Submit")}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
        <div
                      className="fullView collapsePop collapse"
                      id="balliconCollapse"
                      ref={collapseRef}
                    >
                    <div className="balliconCollapse-hed">
                        <h4 className="title">{t("Notifications")}</h4>
                        <div className="balliconcloseIcon">
                          <p
                            className={`${ballcount > 0 ? "cursor-pointer" : "opacity-50"}`}
                            onClick={() => {
                              readballnotification();
                                readnotification();
                            }}
                          >
                            MARK ALL AS READ
                          </p>
                          <button
                            type="button"
                            className="closepopicon"
                            data-bs-toggle="collapse"
                            aria-expanded="false"
                            aria-controls="balliconCollapse"
                            onClick={() => {
                              handleToggleCollapse("balliconCollapse");
                              getnotifications();
                              readnotification();
                            }}
                          >
                            <i class="fa-solid fa-xmark"></i>
                          </button>
                        </div>
 
                      </div>

                      <div className="news-timeline py-2">
                        <div className="container">
                          <div
                            className={`timeline ${!balliconlist?.length && "notshowing"}`}
                          >
                            {balliconlist?.length ? (
                              balliconlist.map((result, key) => {
                                return (
                                  <div className="timeline-item" key={key}>
                                      <div className="timeline-dot">
                                            <i className="fa-solid fa-certificate"></i>
                                          </div>
                                    {result?.type === "adminnotification" ? (
                                      <>
                                       
                                        <div className="news-card">
                                          <div className="news-image">
                                            <img
                                              src={result?.image}
                                              className="img-fluid w-100"
                                              alt=""
                                            />
                                          </div>

                                          <div className="news-content">
                                            <div
                                              className="sec_title text-left"
                                              dangerouslySetInnerHTML={{
                                                __html: result?.message,
                                              }}
                                            ></div>

                                            <div className="news-date">
                                              {
                                                convertLocalToUTCFormatted(
                                                  result?.created_at,
                                                  updatetimezone,
                                                )?.datetime
                                              }
                                            </div>
                                          </div>
                                        </div>
                                         {ballcount > 0 ? (
                                        <div className="afterdot"></div>
                                        ) : (
                                          ""
                                        )}
                                      </>
                                    ) : (
                                      <>
                                      <div
                                        className="news-card p-2"
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          (window.location.href =
                                            result?.notifiable_type ===
                                            "Support"
                                              ? `${base_url}supportdashboard/${result?.data?.support_ticket_id}/${result?.data?.id}`
                                              : "")
                                        }
                                      >
                                        <div className="me-auto">
                                          {result?.notifiable_type}
                                        </div>
                                        <lable>{result?.data?.message}</lable>
                                      </div>
                                      {newNotification ? <div className="afterdot"></div>:""}
                                      </>
                                    )}
                                    
                                  </div>
                                  
                                );
                              })
                            ) : (
                              <p style={{ textAlign: "center" }}>
                                {t("Notifications Not Available")}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
    </React.Fragment>
  );
};

export default Dashboardmenus;
